const DIFF_KANA = 0x60
const DIFF_KAKU = 0xfee0

const katakanaToHiragana = src => {
  return src.replace(/[\u30a1-\u30f6]/g, match => {
    const chr = match.charCodeAt(0) - DIFF_KANA
    return String.fromCharCode(chr)
  })
}

const hiraganaToKatagana = src => {
  return src.replace(/[\u3041-\u3096]/g, match => {
    const chr = match.charCodeAt(0) + DIFF_KANA
    return String.fromCharCode(chr)
  })
}

const zenkakuToHankaku = src => {
  return src.replace(/[\uFF01-\uFF5E]/g, match => {
    const chr = match.charCodeAt(0) - DIFF_KAKU
    return String.fromCharCode(chr)
  })
}

const hankakuToZenkaku = src => {
  return src.replace(/[\u0021-\u007E]/g, match => {
    const chr = match.charCodeAt(0) + DIFF_KAKU
    return String.fromCharCode(chr)
  })
}

const escapeRegExp = string => {
  return string.replace(/[-/\\^$*+?.()|[\]{}]/g, "\\$&")
}

export const generateFuzzyRegExp = searchWord => {
  if (!searchWord) return new RegExp("")
  searchWord = escapeRegExp(searchWord)
  const chars = searchWord.split("").map(char => {
    const hiragana = katakanaToHiragana(char)
    const katakana = hiraganaToKatagana(char)
    const zenkaku = hankakuToZenkaku(char)
    const hankaku = zenkakuToHankaku(char)
    if (hiragana === katakana && zenkaku === hankaku) return char
    if (hiragana === katakana) return `(${zenkaku}|${hankaku})`
    if (zenkaku === hankaku) return `(${hiragana}|${katakana})`
    return `(${hiragana}|${katakana}|${zenkaku}|${hankaku})`
  })
  const fuzzyRegExp = new RegExp(`(${chars.join("")})`, "i")
  return fuzzyRegExp
}

export const coloredResult = (str, searchWord) => {
  if (!searchWord) {
    return str
  }
  return str.replace(generateFuzzyRegExp(searchWord), `<mark>$&</mark>`)
}
